import React from 'react';
import { useQuery } from 'react-query';
import Select, { SelectProps } from 'antd/lib/select';
import { getServiceListByCriteria, ParServiceResponse } from 'services/pricing';

export type ServiceListProps = SelectProps<any> & {
  servcode?: string;
  servlabel?: string;
  servstatus?: string;
  servtype?: string;
  servcategory?: string;
  tpidsupplier?: number;
  onSelected?: (service?: ParServiceResponse) => void;
  onlyServcode?: boolean;
};

const ServiceList = ({
  servcode = '',
  servlabel = '',
  servstatus = '',
  servtype = '',
  servcategory = '',
  tpidsupplier = 0,
  onSelected,
  onlyServcode,
  ...props
}: ServiceListProps) => {
  // eslint-disable-next-line no-unused-vars
  const { data, refetch, isFetching } = useQuery(
    [
      'getServiceListByCriteria',
      servcode,
      servlabel,
      servstatus,
      servtype,
      servcategory,
      tpidsupplier,
    ],
    () =>
      getServiceListByCriteria({
        servcategory,
        servcode,
        servlabel,
        servstatus,
        servtype,
        tpidsupplier,
      })
        .then((res) => {
          return res.list || [];
        })
        .catch((res) => {
          return [];
        })
  );

  const handleChange = (value: any) => {
    onSelected &&
      onSelected(data?.find((service) => service.servcode === value));
  };

  return (
    <Select allowClear loading={isFetching} onSelect={handleChange} {...props}>
      {data?.map((service: ParServiceResponse, index) => (
        <Select.Option value={service.servcode} key={index}>
          {service.servlabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ServiceList;
